/**
 * Directory table columns for Filter Students v2 (pure — Open/Closed registry).
 */

export const DIRECTORY_V2_FLAG = 'students.directory_v2';

export const DIRECTORY_COLUMNS = Object.freeze([
  { id: 'identity', label: 'Student', kind: 'identity' },
  {
    id: 'highestDegreeYear',
    label: 'Highest degree year',
    kind: 'highestDegreeYear',
    fieldKey: 'highestDegreeYear',
    completenessAttr: 'yearOfPassout',
  },
  { id: 'details', label: 'Complete details', kind: 'details' },
  { id: 'actions', label: 'Actions', kind: 'actions' },
]);
